// extracted by mini-css-extract-plugin
export default {"container":"UnauthorizedPage_container__cF409","message_container":"UnauthorizedPage_message_container__x3o7F","message":"UnauthorizedPage_message__9eTVs"};